import { useCallback, useState } from "react"
import { deleteFAQById, retrieveFAQ } from "src/pages/admin/services/whitelistService"

export interface FaqItem {
  id: string;
  slug?: string;
  position?: number;
  isDefault?: boolean;

  questionEn: string;
  questionVi: string;
  questionHi: string;
  questionZh: string;
  questionHk: string;

  answerEn: string;
  answerVi: string;
  answerHi: string;
  answerZh: string;
  answerHk: string;
}

const useFAQ = () => {

  const [faqs, setFaqs] = useState<FaqItem[]>([])

  const retrieve = useCallback(async() => {
    try {
      const response = await retrieveFAQ()
      setFaqs(response.data)
    } catch (error) {
      console.log("error: ", error)
      throw error
    }
  },[])

  return {
    retrieve,
    faqs
  }

}

export default useFAQ